import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  id: "main",
  class: "legal",
  tabindex: "-1"
}
const _hoisted_3 = { class: "legal__hero" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "eyebrow" }
const _hoisted_6 = { class: "legal__lede" }
const _hoisted_7 = { class: "legal__meta" }
const _hoisted_8 = { datetime: "2026-10-01" }
const _hoisted_9 = { class: "container legal__layout" }
const _hoisted_10 = { class: "legal__aside" }
const _hoisted_11 = {
  class: "legal__contents",
  open: ""
}
const _hoisted_12 = {
  class: "legal__toc",
  "aria-label": "On this page"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { "aria-hidden": "true" }
const _hoisted_15 = {
  class: "legal__switch",
  "aria-label": "Legal documents"
}
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = { class: "legal__summary" }
const _hoisted_18 = ["id"]
const _hoisted_19 = {
  class: "legal__num",
  "aria-hidden": "true"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = { class: "sr-only" }
const _hoisted_23 = { scope: "row" }
const _hoisted_24 = {
  key: 2,
  class: "legal__links"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "legal__help" }
const _hoisted_27 = ["href"]

import { computed } from "vue";
import SiteNav from "@/components/site/SiteNav.vue";
import SiteFooter from "@/components/site/SiteFooter.vue";
import {
  legalDocs,
  legalLinks,
  LEGAL_STATUS,
  LegalDocKey,
} from "@/content/legal";
import { SUPPORT_EMAIL } from "@/content/links";

export default /*@__PURE__*/_defineComponent({
  __name: 'LegalView',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props;
const content = computed(() => legalDocs[props.doc]);
const printDocument = () => window.print();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SiteNav, { solid: "" }),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "legal__back",
            to: "/legal"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("← Privacy & terms", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_5, _toDisplayString(content.value.category), 1),
          _createElementVNode("h1", null, _toDisplayString(content.value.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(content.value.intro), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_unref(LEGAL_STATUS)), 1),
            _createElementVNode("span", null, [
              _cache[1] || (_cache[1] = _createTextVNode("Revised ", -1)),
              _createElementVNode("time", _hoisted_8, _toDisplayString(content.value.updated), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: printDocument
            }, [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Print / save PDF ", -1),
              _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1)
            ]))])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("aside", _hoisted_10, [
          _createElementVNode("details", _hoisted_11, [
            _createElementVNode("summary", null, [
              _cache[3] || (_cache[3] = _createTextVNode(" In this document ", -1)),
              _createElementVNode("span", null, _toDisplayString(content.value.sections.length) + " sections", 1)
            ]),
            _createElementVNode("nav", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value.sections, (section, i) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: section.id,
                  href: `#${section.id}`
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(String(i + 1).padStart(2, "0")), 1),
                  _createTextVNode(_toDisplayString(section.heading), 1)
                ], 8, _hoisted_13))
              }), 128))
            ])
          ]),
          _createElementVNode("nav", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalLinks), (link) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: link.key,
                to: link.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(legalDocs)[link.key].title), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ])
        ]),
        _createElementVNode("article", {
          class: "legal__body",
          "aria-label": content.value.title
        }, [
          _createElementVNode("div", _hoisted_17, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "eyebrow" }, "At a glance", -1)),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value.summary, (item) => {
                return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
              }), 128))
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "legal__summary-note" }, " This summary helps you navigate. Read the full document for details. ", -1))
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "legal__draft",
            role: "note"
          }, [
            _createElementVNode("strong", null, "Publication review pending"),
            _createElementVNode("p", null, " Operator identity, contact verification and operational details still need confirmation. This is a review draft, not a finalized legal notice. ")
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value.sections, (section, i) => {
            return (_openBlock(), _createElementBlock("section", {
              id: section.id,
              key: `${__props.doc}-${section.id}`,
              class: "legal__section"
            }, [
              _createElementVNode("h2", null, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(String(i + 1).padStart(2, "0")), 1),
                _createTextVNode(_toDisplayString(section.heading), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.paragraphs, (paragraph, j) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: `p${j}`
                }, _toDisplayString(paragraph), 1))
              }), 128)),
              (section.list)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.list, (item) => {
                      return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (section.table)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "legal__table-wrap",
                    tabindex: "0",
                    role: "region",
                    "aria-label": `${section.heading} table; scroll horizontally on small screens`
                  }, [
                    _createElementVNode("table", null, [
                      _createElementVNode("caption", _hoisted_22, _toDisplayString(section.heading), 1),
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.table.headers, (heading) => {
                            return (_openBlock(), _createElementBlock("th", {
                              key: heading,
                              scope: "col"
                            }, _toDisplayString(heading), 1))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.table.rows, (row, j) => {
                          return (_openBlock(), _createElementBlock("tr", { key: j }, [
                            _createElementVNode("th", _hoisted_23, _toDisplayString(row[0]), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.slice(1), (cell, k) => {
                              return (_openBlock(), _createElementBlock("td", { key: k }, _toDisplayString(cell), 1))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ])
                  ], 8, _hoisted_21))
                : _createCommentVNode("", true),
              (section.links)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.links, (link) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: link.href
                      }, [
                        (link.href.startsWith('/'))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: link.href
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(link.label) + " ", 1),
                                _cache[6] || (_cache[6] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: link.href
                            }, [
                              _createTextVNode(_toDisplayString(link.label) + " ", 1),
                              _cache[7] || (_cache[7] = _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1))
                            ], 8, _hoisted_25))
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_18))
          }), 128)),
          _createElementVNode("div", _hoisted_26, [
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "eyebrow" }, "A question about your account?", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("h2", null, "Let’s make it clear.", -1)),
            _createElementVNode("a", {
              href: `mailto:${_unref(SUPPORT_EMAIL)}`
            }, [
              _createTextVNode(_toDisplayString(_unref(SUPPORT_EMAIL)) + " ", 1),
              _cache[8] || (_cache[8] = _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1))
            ], 8, _hoisted_27),
            _cache[11] || (_cache[11] = _createElementVNode("a", { href: "#main" }, "Back to top ↑", -1))
          ])
        ], 8, _hoisted_16)
      ])
    ]),
    _createVNode(SiteFooter)
  ]))
}
}

})